import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'

@Component({
  standalone: false,
  selector: 'vs-product-not-found',
  templateUrl: './product-not-found.component.html',
  styleUrls: ['./product-not-found.component.scss'],
})
export class ProductNotFoundComponent implements OnInit {
  constructor(private route: Router) {}

  ngOnInit(): void {}
  gotoRequestQuote() {
    this.route.navigate(['quote/cart'])
  }
}
